import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const uMGuacamoleApi = createApi({
  reducerPath: 'uMGuacamoleApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['GuacamoleSession'],
  endpoints: builder => ({
    createGuacamoleSession: builder.mutation({
      query: (body) => ({
        url: `/utils/guacamole/session/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['GuacamoleSession'],
    }),
  }),
});

export const {
  useCreateGuacamoleSessionMutation,
} = uMGuacamoleApi;
